'use client';

import { createPortal } from 'react-dom';

function FloatingPortal(_a) {
    var children = _a.children, nodeRef = _a.nodeRef, enable = _a.enable;
    if (!enable) {
        return children;
    }
    if (typeof window === 'undefined' && !nodeRef) {
        return null;
    }
    var node = (nodeRef === null || nodeRef === void 0 ? void 0 : nodeRef.current) || document.body;
    return createPortal(children, node);
}

export { FloatingPortal as default };
//# sourceMappingURL=FloatingPortal.js.map
